export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f218be2dcf0fd2fa3c7ede763a634551730ca07c8&name=fetchTypeahead!'